import {useContext, useEffect, useState} from "react";
import {IRule, PropsQueryGroup, IMapData} from "../../helpers/Interfaces"
import CondObjAcOne from "../_subcomponents/CondObjAcOne";
import CondObjAcMulti from "../_subcomponents/CondObjAcMulti";
import Button from "../../components/Button"
import SettingsOverscanIcon from '@mui/icons-material/SettingsOverscan';
import TransformIcon from '@mui/icons-material/Transform';
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import {LightTooltip} from "./MapToolsBase";
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import OneRuleDialog from "./OneRuleDialog";
import DialogComment from "./DialogComment";
import AuthContext from "../../context/AuthContext";


interface HomeProps extends PropsQueryGroup {
    rule: IRule;
    level: number;
    currentRules: any[];
    index: number;
    mapData: IMapData;
}

function getValueConditions() {
    const valueConditions = [
        "equal (=)",
        "not equal (!=)",
        "greater than (>)",
        "greater or eq (>=)",
        "less than (<)",
        "less or equal (<=)",
        "in range (# - #)",
        "not in range (!#-#)",
        "start with",
        "not start with",
        "end with",
        "not end with",
        "contain any",
        "not contain any",
        "contain all",
        "not contain all",
        "empty",
        "not empty"
    ]
    return valueConditions.map(item => {
        return <option key={valueConditions.indexOf(item)} value={item}>{item}</option>
    });

}


export default function OneRule(props: HomeProps) {

    let {userPermissions} = useContext(AuthContext)

    const valueConditionsList = getValueConditions()

    let {condObject, setCondObject, rule, level, currentRules, index, mapData} = props

    // HandleChange for MUI Autocomplete & classic DOM inputs
    function handleChange(value: string, name: string) {
        if (name === 'fieldType') {    // cleans residual data if fieldType changed
            for (let k in rule) {
                if (k !== name && k !== 'ID') {
                    rule[k as keyof typeof rule] = ''
                }
        }}

        if (name === "useAS") {
            if (value === "return") {
            // console.log(value)
            rule.returnTemplate = "{value}"
        } else if (value === "condition") {
                rule.returnTemplate = ""
            }
        }

        if (name === "fieldType" && value === "feature") {
            rule.valueCondition = "equal (=)"
            rule.useAS = "condition"
        }

        rule[name as keyof typeof rule] = value
        setCondObject(JSON.parse(JSON.stringify(condObject)))
        // console.log('Object changed')
    }

    function delRule() {
        // console.log(index)
        currentRules.splice(index, 1)
        setCondObject(JSON.parse(JSON.stringify(condObject)))
        // if (currentRules.length > 1 && index !== 0) {
        //     currentRules.splice(index, 1)
        //     setCondObject(JSON.parse(JSON.stringify(condObject)))
        // }
    }

    const [ruleOpen, setRuleOpen] = useState(false);

    const [dialRule, setDialRule] = useState<any>()

    function handleDialogOpen () {
        setDialRule(currentRules[index])
        setRuleOpen(true)
    }


    return (

        <>
            {dialRule &&
                <OneRuleDialog
                    open={ruleOpen}
                    setOpen={setRuleOpen}
                    dialRule={dialRule}
                    setDialRule={setDialRule}
                    condObj={condObject}
                    setCondObj={setCondObject}
                    handleChange={handleChange}
                    mapData={mapData}
                    valueConditions={valueConditionsList}
                    currentRules={currentRules}
                    index={index}
                />
            }

            <div className="rule-container">

                <div><small>|||</small></div>

                {/*<Button type="delete" text="-" disabled={index === 0} onclick={delRule}/>*/}
                {userPermissions.canEdit ? <Button type="delete" text="-" onclick={delRule} />
                    : <Button type="secondary" text="-" onclick={undefined} /> }

                {/* Type of Field */}
                <select
                    id="fieldType"
                    name="fieldType"
                    value={rule.fieldType}
                    onChange={(event) => handleChange(event.target.value, event.target.name)}
                >
                    <option value=""></option>
                    {/* not shown for FeatureMap and TemplateNew */}
                    {/*{mapData.mapType === 'field' && <option value="category">Category</option>}*/}
                    <option value="category">Category</option>
                    <option value="feature">Feature</option>
                    <option value="brand">Brand</option>
                    <option value="family">Family</option>
                    <option value="locale">Locale</option>
                </select>


                {/* Field Name and Field ID */}
                <div style={{height: "25px !important"}}>
                    <CondObjAcOne
                        name="fieldName"
                        fieldType={rule.fieldType}
                        mapData={mapData}
                        val={rule.fieldName}
                        rule={rule}
                        condObject={condObject}
                        setCondObject={setCondObject}
                    />
                </div>


                {/* Value Conditions => must be a multi-select!!! */}
                {rule.fieldType === 'feature' &&
                    <>
                        <select
                            id="valueCondition"
                            name="valueCondition"
                            value={rule.valueCondition}
                            onChange={(event) => handleChange(event.target.value, event.target.name)}
                        >
                            {valueConditionsList}
                        </select>

                        {/* Values or Textline */}
                        <div>
                            <CondObjAcMulti
                                name="values"
                                mapData={mapData}
                                val={rule.values}
                                rule={rule}
                                condObject={condObject}
                                setCondObject={setCondObject}
                            />
                        </div>

                        {/* Use As */}
                        <div className="field-label">as</div>
                        <select
                            id="useAS"
                            name="useAS"
                            value={rule.useAS}
                            onChange={(event) => handleChange(event.target.value, event.target.name)}
                        >
                            <option value="condition">condition</option>
                            <option value="return">return</option>
                        </select>

                        {/*  Return and Transformations template  */}

                        {rule.useAS === "return" ?
                            <input
                                id="return-template"
                                name="returnTemplate"
                                value={rule.returnTemplate}
                                onChange={(event) => handleChange(event.target.value, event.target.name)}
                            />
                            :
                            <div></div>
                        }


                        <div style={{
                            display: 'grid',
                            alignItems: 'center',
                            marginRight: '0',
                            paddingRight: '0',
                            marginLeft: '4px'
                        }}>
                            <LightTooltip title="Expand the rule">
                                <OpenInFullIcon
                                    fontSize="small"
                                    color="action"
                                    className={userPermissions.canEdit ? "icon-clickable" : "icon-nonclickable"}
                                    onClick={userPermissions.canEdit ? handleDialogOpen : undefined}
                                />
                            </LightTooltip>
                        </div>

                    </>
                }

            </div>
        </>

    )
}


